import WPAPI from 'wpapi'

const wp = new WPAPI({
  endpoint: 'https://dashboard.magor.com.br/wp-json'
})

// const wp = new WPAPI({
//   endpoint: 'https://magor.com.br/wp-json'
// })

wp.trabalhos = wp.registerRoute('wp/v2', '/trabalhos/(?P<id>[\\d]+)', {
  params: ['taxo-trabalhos']
})

wp.taxo_trabalhos = wp.registerRoute('wp/v2', '/taxo-trabalhos/(?P<id>[\\d]+)')

wp.works = wp.registerRoute('wp/v2', '/works/(?P<id>[\\d]+)', { params: ['groups'] })

wp.groups = wp.registerRoute('wp/v2', '/groups/(?P<id>[\\d]+)')

export default wp
